import React, { useEffect, useState, memo } from "react";
import styles from "./HomeJugador.module.css";
import { useDispatch, useSelector } from "react-redux";
import Stadistics from "./Estadisticas/Stadistics.jsx";
import Feed from "../Feed/Feed.jsx";
import User from "../User/User.jsx";
import NavSecond from "../../sharedComponents/NavSecond/NavSecond.jsx";
import {
  getEntrenamientos,
  getAllPublicaciones,
  getUserPublicaciones,
  getNoticias,
  getScoresUser,
  getMetricasUser,
} from "../../actions/index.js";

const Home = ({ inVisitor, publicacionView, seguir, isMobile }) => {
  const dataUserLocal = JSON.parse(localStorage.getItem("dataUser"));

  const dispatch = useDispatch();
  const publicaciones = useSelector((state) => state.allPublicaciones);
  const userPublicaciones = useSelector((state) => state.userPubliaciones);
  const entrenamientos = useSelector((state) => state.entrenamientos);
  const scores = useSelector((state) => state.scoresUser);
  const metricas = useSelector((state) => state.metricasUser);
  const noticias = useSelector((state) => state.noticias);
  const [showNavSecond, setShowNavSecond] = useState(true);

  const [displayShow, setDisplayShow] = useState("MÉTRICAS");

  useEffect(() => {
    dispatch(getAllPublicaciones(dataUserLocal.id));
    dispatch(getUserPublicaciones(dataUserLocal.id));
    dispatch(getNoticias());
    dispatch(getEntrenamientos(dataUserLocal.id));
    dispatch(getScoresUser(dataUserLocal.id));
    dispatch(getMetricasUser(dataUserLocal.id));
  }, [dataUserLocal.id, displayShow]);

  const handleDisplayShow = (display) => {
    setDisplayShow(display);
  };

  console.log("isMobile", isMobile);

  return (
    <>
      {isMobile ? (
        <div className={styles.conteiner}>
          <div
            className={styles.leftContainer}
            style={{ display: displayShow === "MÉTRICAS" ? "flex" : "none" }}
          >
            <Stadistics
              entrenamientos={entrenamientos}
              setShowNavSecond={setShowNavSecond}
              isMobile={isMobile}
            />
          </div>

          <div
            className={styles.subContainer}
            style={{ display: displayShow === "MÉTRICAS" ? "flex" : "none" }}
          >
            <User
              user={dataUserLocal}
              entrenamientos={entrenamientos}
              scores={scores}
              metricas={metricas.metricas}
              setShowNavSecond={setShowNavSecond}
              isMobile={isMobile}
            />
          </div>

          <div
            className={styles.subContainer}
            style={{ display: displayShow === "SOCIAL" ? "flex" : "none" }}
          >
            <Feed
              user={dataUserLocal}
              publicaciones={publicaciones}
              inVisitor={inVisitor}
              userPublicaciones={userPublicaciones}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
            />
          </div>

          {showNavSecond && (
            <div className={styles.navSecond}>
              <NavSecond
                handleDisplayShow={handleDisplayShow}
                displayShow={displayShow}
                user={dataUserLocal}
                isVisitor={false}
              />
            </div>
          )}
        </div>
      ) : (
        <div className={styles.conteiner}>
          <div className={styles.leftContainer}>
            <Stadistics entrenamientos={entrenamientos} isMobile={isMobile} />
          </div>

          <div className={styles.subContainer}>
            <User
              user={dataUserLocal}
              entrenamientos={entrenamientos}
              scores={scores}
              metricas={metricas.metricas}
              isMobile={isMobile}
            />
          </div>

          <div className={styles.subContainer}>
            <Feed
              user={dataUserLocal}
              publicaciones={publicaciones}
              inVisitor={inVisitor}
              userPublicaciones={userPublicaciones}
              noticias={noticias}
              publicacionView={publicacionView}
              seguir={seguir}
              isMobile={isMobile}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default memo(Home);
